// 1時間後の日時を取得
export const getOneHourLater = () => {
  const oneHourLater = new Date();
  oneHourLater.setHours(oneHourLater.getHours() + 1);
  return oneHourLater;
};

// 日付入力用の値を生成
export const getDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 時間入力用の値を生成
export const getTimeInputValue = (date: Date) => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

// JST形式のISO文字列を生成
export const formatToJSTISOString = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+09:00`;
};

// プレビュー用のメッセージ内容をリンク形式で表示
export const renderPreviewContent = (content: string) => {
  // [リンク名](URL)形式を検出してリンクとして表示
  const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
  
  return content.split(linkPattern).map((part, index) => {
    if (index % 3 === 1) {
      // リンク名の部分
      const url = content.split(linkPattern)[index + 1];
      return (
        <a 
          key={index} 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="underline hover:no-underline"
        >
          {part}
        </a>
      );
    } else if (index % 3 === 2) {
      // URL部分（表示しない）
      return null;
    } else {
      // 通常のテキスト部分
      return part;
    }
  });
};

// 文字数カウント用のクラス名を取得
export const getCharCountClassName = (length: number, maxLength: number, warningLength: number) => {
  if (length > maxLength) return 'text-red-500';
  if (length > warningLength) return 'text-yellow-600';
  return 'text-gray-400';
};

// 今日の日付を取得（YYYY-MM-DD形式）
export const getTodayDateString = () => {
  const today = new Date();
  return getDateInputValue(today);
};

// 現在時刻を取得（HH:MM形式、分秒は00に固定）
export const getCurrentTimeString = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  return `${hours}:00`;
};

// 指定された日時が現在時刻より過去かどうかをチェック
export const isPastDateTime = (date: Date) => {
  const now = new Date();
  return date < now;
};

// 指定された日付が今日より過去かどうかをチェック
export const isPastDate = (dateString: string) => {
  const today = new Date();
  const inputDate = new Date(dateString);
  
  // 時間を00:00:00に設定して日付のみで比較
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  
  return inputDate < today;
}; 